module.exports = __webpack_public_path__ + "img/not_found_vector.409f2e92.svg";